export const SET_APP_VIEW = Symbol('SET_APP_VIEW');

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function setAppView (view) {

	return {
		type: SET_APP_VIEW,
		appView: view,
	};
}
